import { MOBILE_CHECK_REG, EMAIL_CHECK_REG } from '@/common/constant'

export const checkEmail = (email, errStr) => {
  if (email.trim() === '') {
    return '请输入邮箱地址'
  }
  if(!EMAIL_CHECK_REG.test(email.trim())){
    return errStr || '请检查输入的邮箱地址'
  }
  return true
}

export const checkPhone = (phone, errStr) => {
  if (phone.trim() === '') {
    return '请输入手机号码'
  }
  if(!MOBILE_CHECK_REG.test(phone.trim())){
    return errStr || '请输入有效的手机号'
  }
  return true
}

/**
 * @param {string} str - 要处理的文本 aaaaaa{{bbbb}}
 * @returns {Array} - 包含非空值的对象数组 [{value:aaaaaa,highlight:false},{value:bbbb,highlight:true}]
 */
export const filterHighlightText = (str = '') => {
  const regex = /({{.*?}})/g
  return str.split(regex)
    .map(item => {
      if (item.startsWith('{{') && item.endsWith('}}')) {
        return { value: item.substring(2, item.length - 2), highlight: true }
      }
      return { value: item, highlight: false }
    })
    .filter(({ value }) => value)
}